// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2NiiJ","title":"AfterBackImages_title__1Duz5","images":"AfterBackImages_images__VA160"};